import type { ReactElement } from "react"

import { useTranslation } from "react-i18next"

export const ModuleInverterCompatibilityWarning = ({
  moduleName,
  inverterNames,
  repairInAurora = false,
}: {
  moduleName: string
  inverterNames: string[]
  repairInAurora?: boolean
}): ReactElement => {
  const { i18n, t } = useTranslation()
  const formattedInverters = new Intl.ListFormat(
    i18n.resolvedLanguage ?? i18n.language,
    {
      style: `long`,
      type: `conjunction`,
    },
  ).format(inverterNames)

  return (
    <div
      className="rounded-md border border-danger/30 bg-danger/5 px-4 py-3 text-sm leading-6 text-foreground"
      role="alert"
    >
      <p className="font-semibold text-danger">
        {t(`moduleInverterCompatibilityWarningTitle`)}
      </p>
      <p>
        {t(
          repairInAurora
            ? `auroraModuleInverterCompatibilityWarning`
            : `moduleInverterCompatibilityWarning`,
          {
            module: moduleName,
            inverters: formattedInverters,
          },
        )}
      </p>
    </div>
  )
}

export const NoCompatibleInverterManufacturerWarning = ({
  manufacturer,
  moduleName,
}: {
  manufacturer: string
  moduleName: string
}): ReactElement => {
  const { t } = useTranslation()

  return (
    <div
      className="rounded-md border border-danger/30 bg-danger/5 px-4 py-3 text-sm leading-6 text-foreground"
      role="alert"
    >
      <p className="font-semibold text-danger">
        {t(`noCompatibleInverterManufacturerWarningTitle`)}
      </p>
      <p>
        {t(`noCompatibleInverterManufacturerWarning`, {
          manufacturer,
          module: moduleName,
        })}
      </p>
    </div>
  )
}
